import './chat-product-action.css';
import { ArrowUpRight, Plus } from 'lucide-react';
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../../components/ui/dialog';
import { chatLinkLabel, chatLinkTarget, type ChatLinkTarget } from './chat-links';

export type OpenChatPlatformLink = (target: Extract<ChatLinkTarget, { brandId: number }>) => void;
function textContent(children: React.ReactNode): string {
  return React.Children.toArray(children).map(child => typeof child === 'string' || typeof child === 'number' ? String(child) : React.isValidElement<{ children?: React.ReactNode }>(child) ? textContent(child.props.children) : '').join('');
}

/** Chat links keep their first click inside the app, including historical messages. */
export function ChatMessageLink({ href = '', children, image = false, onOpenPlatform }: { href?: string; children?: React.ReactNode; image?: boolean; onOpenPlatform?: OpenChatPlatformLink }) {
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);
  const target = chatLinkTarget(href);
  const label = chatLinkLabel(href, textContent(children));
  if (!target) return <span>{label}</span>;
  const mediaKind = image ? 'image' : target.kind;
  const internal = target.kind === 'brand' || target.kind === 'product' || target.kind === 'competitor';
  const addProduct = internal && target.createProduct === true;
  return <>
    <button type="button" className={addProduct ? "chat-add-product-action" : "text-amber-800 underline underline-offset-2 hover:text-amber-950"} onClick={() => {
      if (internal && onOpenPlatform) onOpenPlatform(target);
      else { setFailed(false); setOpen(true); }
    }}>{addProduct && <Plus size={16} aria-hidden="true" />}{image && mediaKind === 'image' ? <img src={target.href} alt={label} className="max-h-48 max-w-full object-contain rounded-md" /> : <span>{label}</span>}{addProduct && <ArrowUpRight size={16} aria-hidden="true" />}</button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-auto" data-testid="chat-link-preview">
        <DialogTitle>{label}</DialogTitle>
        <DialogDescription>{mediaKind === 'image' || mediaKind === 'video' ? 'Preview shared in this conversation.' : internal ? 'This platform destination is unavailable in this view.' : 'External source. This site cannot be previewed inside the app.'}</DialogDescription>
        {!failed && mediaKind === 'image' && <img src={target.href} alt={label} className="max-h-[70vh] w-full object-contain rounded-md" onError={() => setFailed(true)} />}
        {!failed && mediaKind === 'video' && <video src={target.href} controls className="max-h-[70vh] w-full" onError={() => setFailed(true)} />}
        {failed && <p role="status">This media could not be loaded.</p>}
        {!internal && (failed || mediaKind === 'source') && <a href={target.href} target="_blank" rel="noopener noreferrer" className="text-amber-800 underline">Open source website</a>}
      </DialogContent>
    </Dialog>
  </>;
}
